import React from 'react'
import { useContext } from 'react'
import styled from 'styled-components'
import authContext from '../context/auth-context'
import { useState } from 'react'
import { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';

const Container = styled.form`
    display: flex;
    justify-content: center;
    input, button{
        padding: 10px;
        border: 1px solid var(--white);
        color: var(--border);
    }
    input{
        padding-left: 20px;
        width: 40%;
        border-radius: 20px;
        :focus, :active{
            border: 1px solid var(--border);
            outline : none;
        }
    }
    button{
        padding: 0.8rem 2rem;
        border-radius: 20px;
        font-size: 1rem;
        cursor: pointer;
        transition: all 0.5s;
        
        &:hover{
            transform: scale(1);
            border: 1px solid var(--border);
        }

        &:active{
            border: 1px solid var(--border);
            transform: scale(0.8);
        }
    }
    
    @media screen and (max-width: 768px) {
        input{
            width:70%;
            font-size:14px;
        }
        button{
            padding: 0.8rem 0.5rem;
        }
    }
`
const Subscribe = () => {
    const {SubscribeToNewsLetter, state} = useContext(authContext)
    const [email, setEmail] = useState("")
    const submitHandler = (e) =>{
        e.preventDefault();
        try{
            SubscribeToNewsLetter(email)
        }
        catch(e){
            alert(e)
        }
    }
    useEffect(()=>{
        if(state.emailSuccess !== undefined && state.emailSuccess){
          toast(`Email Subscribed successfully`, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setEmail('')
        }
        else if(state.emailError !== undefined  && state.emailError?.length > 10){
            toast(`${state.emailError || 'Oops ! something went wrong'}`, {
              position: "bottom-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
        }
        // eslint-disable-next-line
      },[state.emailSuccess, state.emailError])
  return (
    <>
        <h4 className='text-center'>Subscribe to my newsletter.</h4>
        <Container onSubmit={submitHandler}>
            <input required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='email' type='email' />
            <button>Subscribe</button>
        </Container>
        <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            style={{textAlign:'center'}}
            />
    </>
  )
}

export default Subscribe